import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedPolling } from '@eggplant/data-request'
import type {
  GetRunLogsResponse,
  RunLogParams
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  id: string
  interval?: number
  isPolling: boolean
  onSuccess: (data: GetRunLogsResponse) => void
  children?: (data: GetRunLogsResponse) => ReactElement
  params?: RunLogParams
}

const buildUrl = (baseUrl: string, params?: RunLogParams) => {
  if (!params) return baseUrl

  const searchParams = new URLSearchParams()

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined) return

    Array.isArray(value)
      ? value.forEach(item => searchParams.append(key, String(item)))
      : searchParams.append(key, String(value))
  })

  const queryString = searchParams.toString()

  return queryString
    ? `${baseUrl}?${queryString}`
    : baseUrl
}

const PollAiRunLogRequest = ({
  id,
  interval = 1000,
  isPolling,
  onSuccess,
  children,
  params
}: Props) => {
  const url = buildUrl(`${AI_API_SERVICE}/runlogs/${id}`, params)

  return (
    <AuthenticatedPolling<GetRunLogsResponse>
      children={children}
      intervalMs={interval}
      isPolling={isPolling}
      onSuccess={onSuccess}
      url={url}
    />
  )
}

export default PollAiRunLogRequest
